(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SimpleKeyboard", [], factory);
	else if(typeof exports === 'object')
		exports["SimpleKeyboard"] = factory();
	else
		root["SimpleKeyboard"] = factory();
})(window, function() {
return 